<!-- مخالفين شركات -->
<div class="card p-4 me-4">
    <div class="col-12">
        <!-- <button *ngIf="adjudicationDetails && adjudicationDetails.settings.editOffenders" class="btn btn-primary m-3" (click)="openModal(offenderCompany)">
            <i class="fa fa-plus-circle">
            </i>
            <span>
                {{'InsertoffenderCompany' | translate}}
            </span>
        </button> -->
    </div>

    <div class="card p-4 me-4">
        <table class="table table-striped mt-3">
            <thead class="thead-dark">
                <tr>
                    <th>
                        {{ "CommercialRegisterId" | translate }}
                    </th>
                    <th>
                        {{ "CompanyName" | translate }}
                    </th>
                    <th>
                        {{ "MemberType" | translate }}
                    </th> 
                    <th>
                        {{ "Preview" | translate }}
                    </th>
                    <!-- <th *ngIf="adjudicationDetails && adjudicationDetails.settings.editOffenders" scope="col">
                        {{ "Edit" | translate }}
                    </th>

                    <th *ngIf="adjudicationDetails && adjudicationDetails.settings.editOffenders" scope="col">
                        {{ "Delete" | translate }}
                    </th> -->

                </tr>

            </thead>

            <tbody>
                <tr *ngFor="let offender of caseCompaniesList">

                    <td>
                        {{ offender.crNumber }}
                    </td>

                    <td>
                        {{ offender.companyName }}
                    </td>
                    <td>
                        {{ offender.memberTypeName }}
                    </td>
                    <td>
                        <a (click)="previewMember(offender, previewMemberModal)">
                            <i class="fa fa-eye">
                            </i>
                        </a>
                    </td>
                    <!-- <td *ngIf="adjudicationDetails && adjudicationDetails.settings.editOffenders">
                        <a (click)="editOffenderCompany(offender, editOffenderCompanyModal)">
                            <i class="fa fa-edit">
                            </i>
                        </a>
                    </td>
                    <td *ngIf="adjudicationDetails && adjudicationDetails.settings.editOffenders">
                        <a (click)="deleteOffenderCompany(offender.caseCompanyId, deleteModal)">
                            <i class="fa fa-trash">
                            </i>
                        </a>
                    </td> -->
                </tr>
            </tbody>

        </table>
    </div>
</div>



<ng-template #offenderCompany let-modal>

    <div class="modal-header" style="justify-content: space-between">
        <h4 class="modal-title" id="modal-basic-title">
            {{ "InsertoffenderCompany" | translate }}
        </h4>
        <i style="font-size: 20px" class="fa fa-close" (click)="modal.dismiss('Cross click')">
        </i>
    </div>


    <div class="modal-body">
        <div class="card">
            <div class="form-group row ">
                <div class="m-2 row justify-content-between">
                    <div class="col-lg-12 row">
                        

                        <div class="card p-3">
                            <div class="row">
                                <div class="form-group mt-3">
                                    <div style="display: flex; flex-wrap: nowrap; height: 30px">
                                        <label for="CommercialRegistrationNo">
                                            {{ "CommercialRegistrationNo" | translate }}
                                        </label>
                                        <span *ngIf="CommercialRegistrationNo.invalid" class="alert error-span">
                                            <div *ngIf="CommercialRegistrationNo.errors?.required">
                                                *
                                            </div>
                                        </span>
                                        <span *ngIf="CommercialRegistrationNo.invalid" class="alert error-span">
                                            <div *ngIf="CommercialRegistrationNo.errors?.minlength">
                                                {{
                                                "CommercialRegistrationNoMustBe10Number" | translate
                                                }}
                                            </div>
                                        </span>
                                    </div>
                                    <div class="row">
                                        <input [readOnly]="isCompanySearchAndFound"
                                            (keypress)="numberOnly($event,false,false)" required
                                            #CommercialRegistrationNo="ngModel" minlength="10" maxlength="10"
                                            name="CommercialRegistrationNo" id="CommercialRegistrationNo"
                                            [(ngModel)]="commercialRegistrationNo" type="text" class="form-control"
                                            style="width: 30% !important"
                                            placeholder="{{ 'CommercialRegistrationNo' | translate }}" />

                                        <button [disabled]="CommercialRegistrationNo.invalid || isCompanySearchAndFound"
                                            (click)="VerificationCommercialRegistrationNo()"
                                            class="btn btn-primary col-lg-3 me-4" type="button">
                                            {{ "Verification" | translate }}
                                        </button>
                                        <div *ngIf="isCompanySearchAndFound" style="color: green; font-size: 28px"
                                            class="col-lg-1 row align-items-center">
                                            <i class="fa fa-check-circle"></i>
                                        </div>
                                        <button [disabled]="!isCompanySearchAndFound" (click)="resetFacilityDate()"
                                            class="btn btn-danger col-lg-3 me-2" type="button">
                                            {{ "Reset" | translate }}
                                        </button>
                                    </div>
                                </div>

                                <div *ngIf="isCompanySearchAndFound && facility">
                                    <div class="form-group mt-3 row">
                                        <div *ngIf="facility.name" class="col-lg-6">
                                            <div class="divformlabel">
                                                <label>{{
                                                    "NameOfTheCompanyOrInstitution" | translate
                                                    }}</label>
                                            </div>
                                            <input [value]="facility.name" type="text" class="form-control" readonly />
                                        </div>
                                        <div *ngIf="facility.startDate" class="col-lg-3">
                                            <div class="divformlabel">
                                                <label>{{
                                                    "StartDateOfTheEstablishment" | translate
                                                    }}</label>
                                            </div>

                                            <input type="text" [value]="facility.startDate | toDateOnly"
                                                class="form-control" readonly />
                                        </div>

                                        <div *ngIf="facility.endDate" class="col-lg-3">
                                            <div class="divformlabel">
                                                <label>{{
                                                    "ExpirationDateOfTheEstablishment" | translate
                                                    }}</label>
                                            </div>

                                            <input type="text" class="form-control"
                                                [value]="facility.endDate | toDateOnly" readonly />
                                        </div>

                                    </div>
                                    <div class="form-group row">

                                        <div *ngIf="facility.nationalNumber" class="col-lg-2 mt-3">
                                            <label>{{
                                                "NationalEstablishmentNumber" | translate
                                                }}</label>
                                            <input [value]="facility.nationalNumber" type="text" class="form-control"
                                                readonly />
                                        </div>
                                        <div *ngIf="facility.crstatus" class="col-lg-2 mt-3">
                                            <label>{{ "Status" | translate }}</label>
                                            <input [value]="facility.crstatus" type="text" class="form-control"
                                                readonly />
                                        </div>
                                        <div *ngIf="facility.crType" class="col-lg-2 mt-3">
                                            <label>{{ "Type" | translate }}</label>
                                            <input [value]="facility.crType" type="text" class="form-control"
                                                readonly />
                                        </div>
                                        <div *ngIf="facility.city" class="col-lg-2 mt-3">
                                            <label>{{ "CommercialRegistryCity" | translate }}</label>
                                            <input [value]="facility.city" type="text" class="form-control" readonly />
                                        </div>
                                        <div *ngIf="facility.capital" class="col-lg-2 mt-3">
                                            <div class="divformlabel">
                                                <label>{{ "Capital" | translate }}</label>
                                            </div>
                                            <input [value]="facility.capital" type="text" class="form-control"
                                                readonly />
                                        </div>
                                    </div>
                                    <div class="form-group col-lg-12 mt-3">
                                        <label>{{ "Addrress" | translate }}</label>
                                        <span class="form-control" readonly>{{facility.address ? facility.address : ''
                                            }} &nbsp;</span>
                                    </div>
                                    <div class="col-lg-12 mt-3">
                                        <label> {{ "Activity" | translate }} </label>
                                        <span class="form-control" readonly>{{facility ? facility.activity : ''}}
                                            &nbsp;</span>
                                    </div>
                                    <table class="table table-striped mt-5">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th scope="col">{{ "Name" | translate }}</th>
                                                <th scope="col">{{ "IdentityNumber" | translate }}</th>
                                                <th scope="col">
                                                    {{ "RelationshipWithTheInstitution" | translate }}
                                                </th>
                                                <th scope="col">{{ "Email" | translate }}</th>
                                                <th scope="col">{{ "MobileNumber" | translate }}</th>
                                                <th scope="col">{{ "idType" | translate }}</th>
                                                <th scope="col">{{ "Nationality" | translate }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let person of facility.crRelatedPrsons">
                                                <td>{{ person.name }}</td>
                                                <td>{{ person.identityNumber }}</td>
                                                <td>{{ person.relationName }}</td>
                                                <td>{{ person.email }}</td>
                                                <td>{{ person.mobile }}</td>
                                                <td>{{ person.identityTypeName }}</td>

                                                <td><i class="flag-icon flag-icon-{{person.flagFilename }}"></i> {{
                                                    person.nationalityName }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>


                        </div>
                        <div class="col-lg-4 mt-3">
                            <div style="display: flex; flex-wrap: nowrap; height: 30px">
                                <label>
                                    {{ "RelationshipWithTheCase" | translate }}
                                </label>
                                <span *ngIf="MemberType.invalid" class="alert"
                                    style=" color: red; white-space: nowrap; line-height: 0; padding: 0; margin-top: 8px; ">
                                    <div *ngIf="MemberType.errors?.required">
                                        *
                                    </div>
                                </span>
                            </div>
                            <ng-select id="MemberType" name="MemberType" required #MemberType="ngModel"
                                class="form-control-select" [items]="memberTypesArr" bindLabel="text" bindValue="id"
                                [(ngModel)]="memberTypeId" [ngModelOptions]="{ standalone: true }"
                                placeholder="{{ 'RelationshipWithTheCase' | translate }}">
                            </ng-select>
                        </div>
                    </div>


                </div>


            </div>

        </div>
    </div>
    <div class="modal-footer row" style="justify-content: space-between; padding: 1rem 2rem">
        <button (click)="CreateOffenderCompany(modal)" [disabled]="!isCompanySearchAndFound || MemberType.invalid"
            style="color: black; font-weight: bold" type="button" class="btn btn-primary col-lg-3"
            data-bs-dismiss="modal">
            {{ "Add" | translate }}
        </button>


        <button type="button" class="btn btn-danger col-lg-3" (click)="modal.dismiss('Cross click')">
            {{ "Close" | translate }}
        </button>

    </div>

</ng-template>



<ng-template #editOffenderCompanyModal let-modal>
    <div class="modal-header" style="justify-content: space-between">
        <div>
        </div>
        <h4 class="modal-title" id="modal-basic-title">
            {{ "EditoffenderCompany" | translate }}
        </h4>
        <i style="font-size: 20px" class="fa fa-close" (click)="modal.dismiss('Cross click')">
        </i>
    </div>
    <div class="modal-body">
        <div class="custom-form">
            <div class="col-12 offset-1">
                <div class="card p-3">
                 
                    <div class="col-lg-12">
                        <div class="card p-3">
                            <div class="row">
                                <div class="form-group row">
                                    <div class="col-lg-3 mt-3">
                                        <label for="CommercialRegistrationNo">{{"CommercialRegistrationNo" |
                                            translate}}</label>
                                        <span class="form-control" readonly>{{editedObj.crNumber}} &nbsp;</span>
                                    </div>
                                </div>
                                <div *ngIf="facilityEdit">
                                    <div class="form-group mt-3 row">
                                        <div *ngIf="facilityEdit.name" class="col-lg-6">
                                            <div class="divformlabel">
                                                <label>{{
                                                    "NameOfTheCompanyOrInstitution" | translate
                                                    }}</label>
                                            </div>
                                            <input [value]="facilityEdit.name" type="text" class="form-control" readonly />
                                        </div>
                                        <div *ngIf="facilityEdit.startDate" class="col-lg-3">
                                            <div class="divformlabel">
                                                <label>{{
                                                    "StartDateOfTheEstablishment" | translate
                                                    }}</label>
                                            </div>

                                            <input type="text" [value]="facilityEdit.startDate | toDateOnly"
                                                class="form-control" readonly />
                                        </div>

                                        <div *ngIf="facilityEdit.endDate" class="col-lg-3">
                                            <div class="divformlabel">
                                                <label>{{
                                                    "ExpirationDateOfTheEstablishment" | translate
                                                    }}</label>
                                            </div>

                                            <input type="text" class="form-control"
                                                [value]="facilityEdit.endDate | toDateOnly" readonly />
                                        </div>

                                    </div>
                                    <div class="form-group row">

                                        <div *ngIf="facilityEdit.nationalNumber" class="col-lg-2 mt-3">
                                            <label>{{
                                                "NationalEstablishmentNumber" | translate
                                                }}</label>
                                            <input [value]="facilityEdit.nationalNumber" type="text" class="form-control"
                                                readonly />
                                        </div>
                                        <div *ngIf="facilityEdit.crstatus" class="col-lg-2 mt-3">
                                            <label>{{ "Status" | translate }}</label>
                                            <input [value]="facilityEdit.crstatus" type="text" class="form-control"
                                                readonly />
                                        </div>
                                        <div *ngIf="facilityEdit.crType" class="col-lg-2 mt-3">
                                            <label>{{ "Type" | translate }}</label>
                                            <input [value]="facilityEdit.crType" type="text" class="form-control"
                                                readonly />
                                        </div>
                                        <div *ngIf="facilityEdit.city" class="col-lg-2 mt-3">
                                            <label>{{ "CommercialRegistryCity" | translate }}</label>
                                            <input [value]="facilityEdit.city" type="text" class="form-control" readonly />
                                        </div>
                                        <div *ngIf="facilityEdit.capital" class="col-lg-2 mt-3">
                                            <div class="divformlabel">
                                                <label>{{ "Capital" | translate }}</label>
                                            </div>
                                            <input [value]="facilityEdit.capital" type="text" class="form-control"
                                                readonly />
                                        </div>
                                    </div>
                                    <div class="form-group col-lg-12 mt-3">
                                        <label>{{ "Addrress" | translate }}</label>
                                        <span class="form-control" readonly>{{facilityEdit.address ? facilityEdit.address : ''
                                            }} &nbsp;</span>
                                    </div>
                                    <div class="col-lg-12 mt-3">
                                        <label> {{ "Activity" | translate }} </label>
                                        <span class="form-control" readonly>{{facilityEdit ? facilityEdit.activity : ''}}
                                            &nbsp;</span>
                                    </div>
                                    <table class="table table-striped mt-5">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th scope="col">{{ "Name" | translate }}</th>
                                                <th scope="col">{{ "IdentityNumber" | translate }}</th>
                                                <th scope="col">
                                                    {{ "RelationshipWithTheInstitution" | translate }}
                                                </th>
                                                <th scope="col">{{ "Email" | translate }}</th>
                                                <th scope="col">{{ "MobileNumber" | translate }}</th>
                                                <th scope="col">{{ "idType" | translate }}</th>
                                                <th scope="col">{{ "Nationality" | translate }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let person of facilityEdit.crRelatedPrsons">
                                                <td>{{ person.name }}</td>
                                                <td>{{ person.identityNumber }}</td>
                                                <td>{{ person.relationName }}</td>
                                                <td>{{ person.email }}</td>
                                                <td>{{ person.mobile }}</td>
                                                <td>{{ person.identityTypeName }}</td>

                                                <td><i class="flag-icon flag-icon-{{person.flagFilename }}"></i> {{
                                                    person.nationalityName }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row ">
                        <div class="col-lg-4 mt-3">
                            <div style="display: flex; flex-wrap: nowrap; height: 30px">
                                <label>
                                    {{ "RelationshipWithTheCase" | translate }}
                                </label>
                                <span *ngIf="MemberTypeEdit.invalid" class="alert"
                                    style=" color: red; white-space: nowrap; line-height: 0; padding: 0; margin-top: 8px; ">
                                    <span *ngIf="MemberTypeEdit.errors?.required">
                                        *
                                    </span>
                                </span>
                            </div>
                            <ng-select id="MemberTypeEdit" name="MemberTypeEdit" required #MemberTypeEdit="ngModel"
                                (change)="selectMemberTypeEdit($event)" class="form-control-select"
                                [items]="memberTypesArrEdit" bindLabel="text" bindValue="id"
                                [(ngModel)]="editedObj.memberTypeId" [ngModelOptions]="{ standalone: true }"
                                placeholder="{{ 'RelationshipWithTheCase' | translate }}">
                            </ng-select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer row" style="justify-content: space-between; padding: 1rem 2rem">
        <button (click)="onEditOffenderCompany(modal)" [disabled]="!editedObj.memberTypeId"
            style="color: black; font-weight: bold" type="button" class="btn btn-primary col-lg-3"
            data-bs-dismiss="modal">
            {{ "Edit" | translate }}
        </button>
        <button type="button" class="btn btn-danger col-lg-3" (click)="modal.dismiss('Cross click')">
            {{ "Close" | translate }}
        </button>
    </div>
</ng-template>



<ng-template #deleteModal let-modal>
    <div class="modal-header" style="justify-content: center">
        <h4 class="modal-title" id="modal-basic-title">
            {{ "ConfirmDeleteOperation" | translate }}
        </h4>
    </div>
    <div class="modal-body text-center">
        <p>
            {{ "SelectedRecordwillbeDeleted" | translate }}
        </p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="onDeleteOffenderCompany(modal)">
            {{ "Yes" | translate }}
        </button>
        <button type="button" class="btn btn-primary" (click)="modal.dismiss('Cross click')">
            {{ "No" | translate }}
        </button>
    </div>
</ng-template>


<ng-template #previewMemberModal let-modal>

    <div class="modal-header" style="justify-content: space-between">
        <div>
        </div>
        <h4 class="modal-title" id="modal-basic-title">
            {{ "PreviewMember" | translate }}
        </h4>
        <i style="font-size: 20px" class="fa fa-close" (click)="modal.dismiss('Cross click')">
        </i>
    </div>
    <div class="modal-body">
        <div class="form-group row ">
          
            <div class="col-lg-12">
                <div class="card p-3">
                    <div class="row">
                        <div class="form-group row">
                            <div class="col-lg-3 mt-3">
                                <label for="CommercialRegistrationNo">{{"CommercialRegistrationNo" |
                                    translate}}</label>
                                <span class="form-control" readonly>{{editedObj.crNumber}} &nbsp;</span>
                            </div>
                           
                        </div>
                        <div *ngIf="facilityEdit">
                            <div class="form-group mt-3 row">
                                <div *ngIf="facilityEdit.name" class="col-lg-6">
                                    <div class="divformlabel">
                                        <label>{{
                                            "NameOfTheCompanyOrInstitution" | translate
                                            }}</label>
                                    </div>
                                    <input [value]="facilityEdit.name" type="text" class="form-control" readonly />
                                </div>
                                <div *ngIf="facilityEdit.startDate" class="col-lg-3">
                                    <div class="divformlabel">
                                        <label>{{
                                            "StartDateOfTheEstablishment" | translate
                                            }}</label>
                                    </div>

                                    <input type="text" [value]="facilityEdit.startDate | toDateOnly"
                                        class="form-control" readonly />
                                </div>

                                <div *ngIf="facilityEdit.endDate" class="col-lg-3">
                                    <div class="divformlabel">
                                        <label>{{
                                            "ExpirationDateOfTheEstablishment" | translate
                                            }}</label>
                                    </div>

                                    <input type="text" class="form-control"
                                        [value]="facilityEdit.endDate | toDateOnly" readonly />
                                </div>

                            </div>
                            <div class="form-group row">

                                <div *ngIf="facilityEdit.nationalNumber" class="col-lg-2 mt-3">
                                    <label>{{
                                        "NationalEstablishmentNumber" | translate
                                        }}</label>
                                    <input [value]="facilityEdit.nationalNumber" type="text" class="form-control"
                                        readonly />
                                </div>
                                <div *ngIf="facilityEdit.crstatus" class="col-lg-2 mt-3">
                                    <label>{{ "Status" | translate }}</label>
                                    <input [value]="facilityEdit.crstatus" type="text" class="form-control"
                                        readonly />
                                </div>
                                <div *ngIf="facilityEdit.crType" class="col-lg-2 mt-3">
                                    <label>{{ "Type" | translate }}</label>
                                    <input [value]="facilityEdit.crType" type="text" class="form-control"
                                        readonly />
                                </div>
                                <div *ngIf="facilityEdit.city" class="col-lg-2 mt-3">
                                    <label>{{ "CommercialRegistryCity" | translate }}</label>
                                    <input [value]="facilityEdit.city" type="text" class="form-control" readonly />
                                </div>
                                <div *ngIf="facilityEdit.capital" class="col-lg-2 mt-3">
                                    <div class="divformlabel">
                                        <label>{{ "Capital" | translate }}</label>
                                    </div>
                                    <input [value]="facilityEdit.capital" type="text" class="form-control"
                                        readonly />
                                </div>
                            </div>
                            <div class="form-group col-lg-12 mt-3">
                                <label>{{ "Addrress" | translate }}</label>
                                <span class="form-control" readonly>{{facilityEdit.address ? facilityEdit.address : ''
                                    }} &nbsp;</span>
                            </div>
                            <div class="col-lg-12 mt-3">
                                <label> {{ "Activity" | translate }} </label>
                                <span class="form-control" readonly>{{facilityEdit ? facilityEdit.activity : ''}}
                                    &nbsp;</span>
                            </div>
                            <table class="table table-striped mt-5">
                                <thead class="thead-dark">
                                    <tr>
                                        <th scope="col">{{ "Name" | translate }}</th>
                                        <th scope="col">{{ "IdentityNumber" | translate }}</th>
                                        <th scope="col">
                                            {{ "RelationshipWithTheInstitution" | translate }}
                                        </th>
                                        <th scope="col">{{ "Email" | translate }}</th>
                                        <th scope="col">{{ "MobileNumber" | translate }}</th>
                                        <th scope="col">{{ "idType" | translate }}</th>
                                        <th scope="col">{{ "Nationality" | translate }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let person of facilityEdit.crRelatedPrsons">
                                        <td>{{ person.name }}</td>
                                        <td>{{ person.identityNumber }}</td>
                                        <td>{{ person.relationName }}</td>
                                        <td>{{ person.email }}</td>
                                        <td>{{ person.mobile }}</td>
                                        <td>{{ person.identityTypeName }}</td>

                                        <td><i class="flag-icon flag-icon-{{person.flagFilename }}"></i> {{
                                            person.nationalityName }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 mt-3">
                <label>
                    {{ "RelationshipWithTheCase" | translate }}
                </label>
                <span class="form-control" readonly>
                    {{editedObj.memberTypeName}}&nbsp;
                </span>
            </div>
        </div>


    </div>
    <div class="modal-footer row" style="justify-content: flex-end; padding: 1rem 2rem">
        <button type="button" class="btn btn-danger col-lg-2" (click)="modal.dismiss('Cross click')">
            {{ "Close" | translate }}
        </button>
    </div>

</ng-template>